const $ = jQuery.noConflict();


class MegaMenu {
	constructor() {
		this.menu = $(
			'.main-header__nav, .main-header__nav-mobile, .main-header__sub-nav, .top-mobile'
		);
		this.menuItems = this.menu.find(
			'> .menu > .menu-item-object-ccs_custom_menu_item'
		);
		this.menuItemsLinks = this.menuItems.find('> a');
	}
	static showMegaMenu() {
		const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');
		const timer =
			$('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

		MegaMenu.menuTimeout = setTimeout(() => {
			megaMenuCols.each((i, v) => {
				MegaMenu.animateItemsIn($(v).find('*'));
			});

			megaMenuWrapper.addClass('active');
			MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
		}, timer);
	}
	static hideMegaMenu() {
		clearTimeout(MegaMenu.menuTimeout);
		const activeMegaMenu = $('.mega-menu-wrapper.active');
		const activeMegaMenuItems = activeMegaMenu.find('*');
		const mainHeader = $('.main-header'); // <-- Reference to the main-header
		const parentLi = $('.menu-item-object-ccs_custom_menu_item');
		const navMenu = $('.main-header__nav-mobile--wrapper');

		activeMegaMenu.removeClass('active');
		activeMegaMenuItems.removeClass('active');
		$('.menu-item-top-level').removeClass('active');
		mainHeader.removeClass('in-view'); // <-- Remove 'in-view' class from the main-header
		parentLi.removeClass('active');
		navMenu.removeClass('active-items');
		MegaMenu.animateMenuBackground(0);
	}

	static hideMegaMenuOnTouch(e) {
		const container = $('.main-header__nav, .main-header__nav-mobile');
		if (
			!container.is(e.target) &&
			container.has(e.target).length === 0 &&
			$('.mega-menu-wrapper').hasClass('active')
		) {
			MegaMenu.hideMegaMenu();
		}
		// console.log('click');

		if (!$(e.target).closest('.menu-item-type-post_type').length) {
			$('.main-header__sub-nav > .menu > .menu-item-type-post_type > a.active').removeClass('active');
			MegaMenu.hideMegaMenu();
		}
	}
	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.04;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}
	static animateMenuBackground(height) {
		// console.log(height);
		if (height === 0) {
			$('.main-header .mega-menu-background')
				.stop()
				.animate(
					{
						height: `0px`,
					},
					300
				);
		} else {
			$('.main-header .mega-menu-background').stop().animate(
				{
					height: `100vh`,
				},
				300
			);
		}
	}

	bindEvents() {
		this.menuItemsLinks.on('click', this.toggleMegaMenu.bind(this)); // Bind this for the function scope
		$(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
		$('.open-search').on('click', this.toggleSearchForm); // New event binding
	}

	toggleMegaMenu(e) {
		e.preventDefault();

		const menuItem = $(e.currentTarget); // Accessing the parent, which is the .menu-item-object-ccs_custom_menu_item
		const parentOfMenuItem = menuItem.parent(); // Direct parent of the clicked .menu-item-object-ccs_custom_menu_item
		const MobileNavMenu = $('.main-header__nav-mobile--wrapper');

		// Check if clicked menuItem is active
		if (menuItem.hasClass('active')) {
			MegaMenu.hideMegaMenu();
			menuItem.removeClass('active');
			MobileNavMenu.removeClass('active-items');

			parentOfMenuItem.removeClass('active'); // Toggle 'active' class on the direct parent
			return;
		}

		const megaMenuWrapper = $(e.currentTarget).next('.mega-menu-wrapper');
		const mainHeader = $('.main-header'); // <-- Reference to the main-header

		// If another menu is active, hide it
		if ($('.mega-menu-wrapper.active').length) {
			MegaMenu.hideMegaMenu();
			this.menuItems.removeClass('active');
		}

		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');

		megaMenuCols.each((i, v) => {
			MegaMenu.animateItemsIn($(v).find('*'));
		});

		megaMenuWrapper.addClass('active');
		menuItem.addClass('active'); // Add 'active' class to the clicked menuItem
		parentOfMenuItem.addClass('active'); // Toggle 'active' class on the direct parent
		MobileNavMenu.addClass('active-items');

		mainHeader.addClass('in-view'); // <-- Add 'in-view' class to the main-header
		MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
	}

	toggleSearchForm(e) {
		const searchForm = $('.header-search-form');
		if (e.target.classList.contains('is-active')) {
			e.target.classList.remove('is-active');
		} else {
			e.target.classList.add('is-active');
		}

		// Check if searchForm is active
		if (searchForm.hasClass('active')) {
			searchForm.removeClass('active');
			$('body').removeClass('overlayed-search');
		} else {
			searchForm.addClass('active');
			$('body').addClass('overlayed-search');
		}
	}

	init() {
		this.bindEvents();
	}
}
export default new MegaMenu();
